import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, Observable } from '../common';
import { BaseResponse, IBinnaclesResponse } from '../models/responses';
import { AppConstants } from '../common/constants';
import { IBinnacle } from '../models/i-binnacle';
@Injectable({
  providedIn: 'root'
})
export class BinnacleService {
  

  constructor(private httpClient: HttpClient) { }

  GetBinnacle(From:string, To:string, DocEntry:string, Event:string, Type: string):Observable<IBinnaclesResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const url = `
    ${AppConstants.API_URL}api/Binnacle/GetBinnacleFilter?From=${From}&To=${To}
    ${(Event)?'&Event='+Event:""}
    ${(Type)?'&Type='+Type:""}
    ${(DocEntry)?'&DocEntry='+DocEntry:""}
    `;
    
    return this.httpClient.get<IBinnaclesResponse>(url, { headers });
  }
}
